import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-answer",
  "use": "vab-icon-answer-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-answer\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.8911 1.09858C15.1839 1.39147 15.1839 1.86635 14.8911 2.15924L6.45882 10.5915C6.13663 10.9136 5.61427 10.9136 5.29208 10.5915L1.10248 6.40187C0.80959 6.10899 0.80959 5.63409 1.10248 5.34122C1.39537 5.04834 1.87025 5.04834 2.16314 5.34122L5.87545 9.05349L13.8304 1.09858C14.1233 0.805682 14.5982 0.805682 14.8911 1.09858Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol